import { Title } from '@e2n/ui/v2';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function LinkBerechnungsbeispiel() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-3">
      <Title>
        {t(
          'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.berechnungsbeispiel.label',
        )}
      </Title>
      <a
        href="https://hilfe.e2n.de/bewertung-von-abwesenheiten#dynamische-berechnung"
        target="_blank"
        rel="noreferrer noopener"
        className="flex gap-2 py-2 px-3 items-center rounded-md text-brand-red-200 hover:text-brand-red-300 disabled:text-neutrals-v2-600">
        <FontAwesomeIcon icon={faArrowRight} className="size-5" />

        {t(
          'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.berechnungsbeispiel.link',
        )}
      </a>
    </div>
  );
}
